export default __webpack_public_path__ + "static/media/download (7).bc26baf9.svg";